import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { BLDetailsList } from '../types';

import {
  // getBLListWithBlnumber,
  // getBlDashboardDefinition,
  getBlsList,
  // getBlsListFilter,
  getDashboardData,
  //todo bllist
  // getDashboardData,
  exportDashboardData,
  searchWithBlno,
  searchWithContainerno,
  searchWithInternalVoyageNo,
  searchWithInternalVoyageNoPaymentDashboard,
  searchWithShipmentNoBlDashboard,
  searchWithShipmentno,
} from '../actions/dashboard';
import { IDataTableColumn } from '../../../common/types/dataTable';
import { IConfigsDefinition } from '../../../utils/columnConfig';
import { PaymentBlDetails } from '../../payment/paymentSlice';
import { string } from 'yup';

interface IBlList {
  list: BLDetailsList[];
  next: string | null;
  previous: string | null;
}

interface IBlDependency {
  prevLocation: string;
  prevFilterState: string;
  prevDataCountry: string;
  prevPage: number;
  prevPageInstructionDashbaord: number;
  prevPageRegistrationDashbaord: number;
  prevselectedConfigId: string;
  prevPartnerType: string;
}

interface DashboardSlice {
  result: any[];
  data: IBlList;
  showPayment: any;
  showInstruction: any;
  showRelease: any;
  dataLoading: boolean;
  showColumnSettings: boolean;
  myPaymentPopUp:boolean;
  usBlDashboardPopUp:boolean;
  joBlDashboardPopUp:boolean;
  hkBlDashboardPopUp:boolean;
  showBlExists: boolean;
  showAddAgent: boolean;
  showNonimationReq: boolean;
  enableDeliveryOrderEntry: boolean;
  enableAddAgentButton: boolean;
  blDashboardDefinition: any[];
  blDashboardDefinitionLoading: boolean;
  columns: IDataTableColumn[];
  configs: IConfigsDefinition;
  setDefaultViewBL: boolean;
  setDefaultViewInvoice: boolean;
  currentGridName: string;
  blDashboardList: {
    maxPage: number | null;
    hasNext: boolean;
    size: number | null;
    result: BLDetailsList[];
  };

  invoiceDashboardList: {
    [x: string]: any;
    maxPage: string | null;
    hasNext: boolean;
    size: string | null;
    result: PaymentBlDetails[];
  };
  instructionDashboardList: {
    maxPage: string | null;
    hasNext: boolean;
    size: string | null;
    result: PaymentBlDetails[];
  };
  registrationDashboardList: {
    maxPage: string | null;
    hasNext: boolean;
    size: string | null;
    result: any[];
  };
  masterTruckerDashboardList: {
    maxPage: string | null;
    hasNext: boolean;
    size: string | null;
    result: any[];
  };
  helpDocumentList: {
    maxPage: string | null;
    hasNext: boolean;
    size: string | null;
    result: any[];
  };
  paymentFundList: {
    maxPage: string | null;
    hasNext: boolean;
    size: string | null;
    result: PaymentBlDetails[];
  };
  emailTemplateList: {
    maxPage: string | null;
    hasNext: boolean;
    size: string | null;
    result: PaymentBlDetails[];
  };

  userDashboardList: {
    maxPage: string | null;
    hasNext: boolean;
    size: string | null;
    result: PaymentBlDetails[];
  };
  customerCodeDashboardList: {
    maxPage: string | null;
    hasNext: boolean;
    size: string | null;
    result: any[];
  };
  paymentDashboardList:{
    maxPage: string | null;
    hasNext: boolean;
    size : string | null;
    result: PaymentBlDetails[];

  };
  bulkpaymentDashboardList:{
    maxPage: string | null;
    hasNext: boolean;
    size : string | null;
    result: PaymentBlDetails[];

  };
  mappingDashboardList:{
    maxPage: string | null;
    hasNext: boolean;
    size : string | null;
    result: PaymentBlDetails[];

  };
  sezDashboardList:{
    maxPage: string | null;
    hasNext: boolean;
    size : string | null;
    result: PaymentBlDetails[];

  };
  receiptDashboardList:{
    maxPage: string | null;
    hasNext: boolean;
    size : string | null;
    result: PaymentBlDetails[];

  };
  emailDashboardList:{
    maxPage: string | null;
    hasNext: boolean;
    size : string | null;
    result: any[];

  };
   payorDashboardList:{
    maxPage: string | null;
    hasNext: boolean;
    size : string | null;
    result: any[];

  };
   getInGetOutDashboardList:{
    maxPage: string | null;
    hasNext: boolean;
    size : string | null;
    result: PaymentBlDetails[];

  };
  reportDashboardList:{
    maxPage: string | null;
    hasNext: boolean;
    size : string | null;
    result: any[];
  };
  standingInstructionList: {
    maxPage: string | null;
    hasNext: boolean;
    size: string | null;
    result: PaymentBlDetails[];
  };

  currentPage: number | any;
  currentPageInvoice: number | any;
  currentPageReceipt: number | any;
  currentPageEmail: number | any;
  currentPagePayor: number | any;
  currentPageGetInGetOut: number | any;
  currentPagePayment: number | any;
  currentPageMapping: number | any;
  currentPageSez: number | any;
  currentPageReport: number | any;
  currentPageInstruction: number | any;
  currentPageRegistration: number | any;
  currentPageUser: number | any;
  currentPageCustomerCode: number | any;
  currentPageStandingInst: number | any;
  prevDependencies: IBlDependency;
  selectedData: any[];
  selectedBlDataRows: any;
  selectedInstDataRows: any;
  assignTo: any;
}

const initialState: DashboardSlice = {
  data: {
    next: null,
    previous: null,
    list: [],
  },
  dataLoading: true,
  showPayment: '',
  showInstruction: '',
  showRelease: '',
  showColumnSettings: false,
  myPaymentPopUp:true,
  usBlDashboardPopUp:true,
  joBlDashboardPopUp:true,
  hkBlDashboardPopUp:true,
  showAddAgent: false,
  showBlExists: false,
  enableAddAgentButton: false,
  enableDeliveryOrderEntry: false,
  showNonimationReq: false,
  blDashboardDefinition: [],
  blDashboardDefinitionLoading: false,
  columns: [],
  configs: {
    columns: [],
    staticHiddenCols: [],
    defaultHiddenCols: [],
  },
  setDefaultViewBL: true,
  setDefaultViewInvoice: true,
  blDashboardList: {
    maxPage: null,
    hasNext: false,
    size: null,
    result: [],
  },
  getInGetOutDashboardList: {
    maxPage: null,
    hasNext: false,
    size: null,
    result: [],
  },
  helpDocumentList:{
    maxPage:null,
    hasNext:false,
    size:null,
    result:[],
  },
  masterTruckerDashboardList: {
    maxPage: null,
    hasNext: false,
    size: null,
    result: [],
  },
  invoiceDashboardList: {
    maxPage: null,
    hasNext: false,
    size: null,
    result: [],
  },
  instructionDashboardList: {
    maxPage: null,
    hasNext: false,
    size: null,
    result: [],
  },
  registrationDashboardList: {
    maxPage: null,
    hasNext: false,
    size: null,
    result: [],
  },
  reportDashboardList: {
    maxPage: null,
    hasNext: false,
    size: null,
    result: [],
  },
  paymentFundList: {
    maxPage: null,
    hasNext: false,
    size: null,
    result: [],
  },
  emailTemplateList: {
    maxPage: null,
    hasNext: false,
    size: null,
    result: [],
  },
  userDashboardList: {
    maxPage: null,
    hasNext: false,
    size: null,
    result: [],
  },
  customerCodeDashboardList: {
    maxPage: null,
    hasNext: false,
    size: null,
    result: [],
  },
  paymentDashboardList:{
    maxPage:null,
    hasNext: false,
    size: null,
    result: []
  },
  bulkpaymentDashboardList:{
    maxPage:null,
    hasNext: false,
    size: null,
    result: []
  },
  receiptDashboardList:{
    maxPage:null,
    hasNext: false,
    size: null,
    result: []
  },
  emailDashboardList:{
    maxPage:null,
    hasNext: false,
    size: null,
    result: []
  },
    payorDashboardList:{
    maxPage:null,
    hasNext: false,
    size: null,
    result: []
  },
  mappingDashboardList:{
    maxPage:null,
    hasNext: false,
    size: null,
    result: []
  },
  sezDashboardList:{
    maxPage:null,
    hasNext: false,
    size: null,
    result: []
  },
  standingInstructionList: {
    maxPage: null,
    hasNext: false,
    size: null,
    result: [],
  },
  currentPage: 1,
  currentPagePayment: 1,
  currentPageMapping: 1,
  currentPageSez: 1,
  currentPageInvoice: 1,
  currentPageReceipt:1,
  currentPageEmail:1,
  currentPagePayor:1,
  currentPageInstruction: 1,
  currentPageReport: 1,
  currentPageRegistration: 1,
  currentPageUser: 1,
  currentPageCustomerCode: 1,
  currentPageStandingInst: 1,
  currentPageGetInGetOut:1,
  prevDependencies: {
    prevLocation: '',
    prevFilterState: '',
    prevDataCountry: '',
    prevPage: 0,
    prevselectedConfigId: '',
    prevPartnerType: '',
    prevPageInstructionDashbaord: 0,
    prevPageRegistrationDashbaord: 0,
  },
  result: [],
  selectedData: [],
  selectedBlDataRows: {},
  currentGridName: '',
  assignTo: '',
  selectedInstDataRows: {}
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    updateCurrentPageBlDashboard: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    updateCurrentPagePayment: (state, action: PayloadAction<number>) => {
      state.currentPagePayment = action.payload;
    },
    updateCurrentPageMapping: (state, action: PayloadAction<number>) => {
      state.currentPageMapping = action.payload;
    },
    updateCurrentPageSez: (state, action: PayloadAction<number>) => {
      state.currentPageSez = action.payload;
    },
    updateCurrentPageInvoiceDashboard: (
      state,
      action: PayloadAction<number>
    ) => {
      state.currentPageInvoice = action.payload;
    },
    updateCurrentPageReceiptDashboard:(
      state,
      action: PayloadAction<number>
    ) => {
      state.currentPageReceipt = action.payload;
    },
    updateCurrentPageEmailDashboard:(
      state,
      action: PayloadAction<number>
    ) => {
      state.currentPageEmail = action.payload;
    },
     updateCurrentPagePayorDashboard:(
      state,
      action: PayloadAction<number>
    ) => {
      state.currentPagePayor = action.payload;
    },
    updateCurrentPageInstructionDashboard: (
      state,
      action: PayloadAction<number>
    ) => {
      state.currentPageInstruction = action.payload;
    },
    updateCurrentPageUserDashboard: (state, action: PayloadAction<number>) => {
      state.currentPageUser = action.payload;
    },
    updateCurrentPageCustomerCodeDashboard: (state, action: PayloadAction<number>) => {
      state.currentPageCustomerCode = action.payload;
    },
    updateCurrentPageReportDashboard: (state, action: PayloadAction<number>) => {
      state.currentPageReport = action.payload;
    },
    updateCurrentPageStandingInst: (state, action: PayloadAction<number>) => {
      state.currentPageStandingInst = action.payload;
    },
    updateCurrentPageRegistrationDashboard: (
      state,
      action: PayloadAction<number>
    ) => {
      state.currentPageRegistration = action.payload;
    },
    updatePrveDependenciesBlDashboard: (
      state,
      action: PayloadAction<{
        key: keyof IBlDependency;
        value: string | number | any;
      }>
    ) => {
      if (action.payload.key === 'prevLocation') {
        state.prevDependencies.prevLocation = action.payload.value;
      } else if (action.payload.key === 'prevFilterState') {
        state.prevDependencies.prevFilterState = action.payload.value;
      } else if (action.payload.key === 'prevDataCountry') {
        state.prevDependencies.prevDataCountry = action.payload.value;
      } else if (action.payload.key === 'prevPage') {
        state.prevDependencies.prevPage = action.payload.value;
      } else if (action.payload.key === 'prevselectedConfigId') {
        state.prevDependencies.prevselectedConfigId = action.payload.value;
      } else if (action.payload.key === 'prevPartnerType') {
        state.prevDependencies.prevPartnerType = action.payload.value;
      } else if (action.payload.key === 'prevPageInstructionDashbaord') {
        state.prevDependencies.prevPageInstructionDashbaord =
          action.payload.value;
      } else if (action.payload.key === 'prevPageRegistrationDashbaord') {
        state.prevDependencies.prevPageRegistrationDashbaord =
          action.payload.value;
      }
    },
    updateSetDefaultViewBL: (state, action: PayloadAction<boolean>) => {
      state.setDefaultViewBL = action.payload;
    },
    updateSetDefaultViewInvoice: (state, action: PayloadAction<boolean>) => {
      state.setDefaultViewInvoice = action.payload;
    },
    updateDashboardBlList: (state, action: PayloadAction<IBlList>) => {
      state.data = action.payload;
    },
    updateColumnDefinitionConfigs: (
      state,
      action: PayloadAction<IConfigsDefinition>
    ) => {
      state.configs = action.payload;
    },
    updateColumnDefinition: (
      state,
      action: PayloadAction<IDataTableColumn[]>
    ) => {
      state.columns = action.payload;
    },
    getPaymentStatus: (state, action: PayloadAction<IBlList>) => {
      state.showPayment = action.payload;
    },
    getInstructionStatus: (state, action: PayloadAction<IBlList>) => {
      state.showInstruction = action.payload;
    },
    getReleaseStatus: (state, action: PayloadAction<IBlList>) => {
      state.showRelease = action.payload;
    },
    toggleColumnSettingsDashboard: (state, action: PayloadAction<boolean>) => {
      state.showColumnSettings = action.payload;
    },
    setMyPaymentPopUp: (state, action: PayloadAction<boolean>) => {
      state.myPaymentPopUp = action.payload;
    },
    setUsDashboardPopUp:(state, action: PayloadAction<boolean>)=>{
      state.usBlDashboardPopUp = action.payload
    },
    setJoDashboardPopUp:(state,action: PayloadAction<boolean>)=>{
      state.joBlDashboardPopUp = action.payload
    },
    setHkBlDashboardPopUp:(state,action: PayloadAction<boolean>)=>{
      state.hkBlDashboardPopUp = action.payload
    },
    
    toggleAddAgent: (state, action: PayloadAction<boolean>) => {
      state.showAddAgent = action.payload;
    },
    toggleIsBlExists: (state, action: PayloadAction<boolean>) => {
      state.showBlExists = action.payload;
    },
    toggleAddAgentButton: (state, action: PayloadAction<boolean>) => {
      state.enableAddAgentButton = action.payload;
    },
    toggleDeliveryOrderEntry: (state, action: PayloadAction<boolean>) => {
      state.enableDeliveryOrderEntry = action.payload;
    },
    toggleNominationReq: (state, action: PayloadAction<boolean>) => {
      state.showNonimationReq = action.payload;
    },
    updateSelectedTableData: (state, action: PayloadAction<any[]>) => {
      state.selectedData = action.payload;
    },
    addSelectionToTableData: (state, action: PayloadAction<any[]>) => {
      if(state.selectedData.length>=1){
        state.selectedData = [...state.selectedData, ...action.payload];
      } else {
        state.selectedData = action.payload;
      }
    },
    removeSelectionfromTable: (state, action: PayloadAction<any[]>) => {
      state.selectedData = state.selectedData.filter(
        (B) => action.payload.findIndex((A) => A.blid === B.blid) == -1
      );
    },
    removeSelectionfromInstTable: (state, action: PayloadAction<any[]>) => {
      state.selectedData = state.selectedData.filter(
        (B) => action.payload.findIndex((A) => A.bl_event_id === B.bl_event_id) == -1
      );
    },
    updateSelectedRow: (state, action: PayloadAction<any>) => {
      state.selectedBlDataRows = action.payload;
    },
    updateSelectedInstRow: (state, action: PayloadAction<any>) => {
      state.selectedInstDataRows = action.payload;
    },
    updateAssigneTo: (state, action: PayloadAction<any>) => {
      state.assignTo = state.assignTo + action.payload;
    },
    clearDashboards:(state)=>{
      state.blDashboardList.result = []
      state.invoiceDashboardList.result = []
      state.instructionDashboardList.result = []
      state.paymentFundList.result = []
      state.helpDocumentList.result=[]
      state.emailTemplateList.result = []
      state.userDashboardList.result = []
      state.customerCodeDashboardList.result = []
      state.standingInstructionList.result = []
      state.registrationDashboardList.result = []
      state.paymentDashboardList.result =[]
      state.bulkpaymentDashboardList.result =[]
      state.receiptDashboardList.result =[]
      state.emailDashboardList.result =[]
      state.payorDashboardList.result =[]
      state.reportDashboardList.result = [];
      state.mappingDashboardList.result = []
      state.sezDashboardList.result = []
    },
    clearMappingDashboard:(state)=>{
      state.mappingDashboardList.result = []
    },
    clearSezDashboard:(state)=>{
      state.sezDashboardList.result = []
    }
  },
  extraReducers: (builder) => {
    // builder.addCase(getBlDashboardDefinition.pending, (state, action) => {
    //   state.blDashboardDefinitionLoading = true;
    // });
    // builder.addCase(getBlDashboardDefinition.fulfilled, (state, action) => {
    //   state.blDashboardDefinitionLoading = false;
    //   state.blDashboardDefinition = action.payload;
    // });
    builder.addCase(getBlsList.pending, (state, action) => {
      state.dataLoading = true;
    });
    builder.addCase(getBlsList.fulfilled, (state: any, action) => {
      state.dataLoading = false;
      state.data = action.payload;
    });
    // builder.addCase(getBlsListFilter.pending, (state, action) => {
    //   state.dataLoading = true;
    // });
    // builder.addCase(getBlsListFilter.fulfilled, (state, action) => {
    //   state.dataLoading = false;

    //   state.data = action.payload;
    // });
    //todo bllist
    builder.addCase(getDashboardData.pending, (state, action) => {
      state.dataLoading = true;
      const blank = () =>({
        maxPage: null,
        hasNext: false,
        size: null,
        result: [],
      })
      state.blDashboardList = blank()
      state.invoiceDashboardList = blank()
      state.instructionDashboardList = blank()
      state.paymentFundList = blank()
      state.helpDocumentList=blank()
      state.emailTemplateList = blank()
      state.userDashboardList = blank()
      state.customerCodeDashboardList = blank()
      state.standingInstructionList = blank()
      state.registrationDashboardList = blank()
      state.paymentDashboardList = blank()
      state.bulkpaymentDashboardList = blank()
      state.receiptDashboardList = blank()
      state.emailDashboardList = blank()
      state.payorDashboardList = blank()
      state.reportDashboardList = blank()
      state.mappingDashboardList = blank()
      state.sezDashboardList = blank()
    });
    builder.addCase(getDashboardData.fulfilled, (state, action) => {
      // setTimeout(() => {

      // }, 1000);
      console.log("ction?.payload?.gridName;",action?.payload?.gridName)
      state.currentGridName = action?.payload?.gridName;
      if (
        action?.payload?.data?.asCsv &&
        action?.payload?.data?.asCsv === true
      ) {
      } else {
        console.log(action.payload?.gridName,'<<<gridName')
        switch (action?.payload?.gridName) {
          case 'BL_DASHBOARD_LINER':
            state.blDashboardList = action.payload.data;
            break;
          case 'BL_DASHBOARD_CUSTOMER':
              state.blDashboardList = action.payload.data;
              break;
          case 'INVOICE_DASHBOARD_LINER':
            state.invoiceDashboardList = action.payload.data;
            break;
          case 'INVOICE_DASHBOARD_CUSTOMER':
              state.invoiceDashboardList = action.payload.data;
              break;
          case 'INSTRUCTION_DASHBOARD_CUSTOMER':
            state.instructionDashboardList = action.payload.data;
            break;
   
          case 'INSTRUCTION_DASHBOARD_LINER':
              state.instructionDashboardList = action.payload.data;
              break;
          case 'PAYMENT_FUNDING':
            state.paymentFundList = action.payload.data;
            break;
          case 'EMAIL_TEMPLATE':
          state.emailTemplateList = action.payload.data;
            break;
          case 'USER_DASHBOARD':
            state.userDashboardList = action.payload.data;
            break;
          case 'CUSTOMER_CODE_DASHBOARD':
            state.customerCodeDashboardList = action.payload.data;
            break;
          case 'STANDING_INSTRUCTION':
            state.standingInstructionList = action.payload.data;
            break;
          case 'REGISTRATION_DASHBOARD':
            state.registrationDashboardList = action.payload.data;
            break;
          case 'MASTER_TRUCKER':
              state.masterTruckerDashboardList = action.payload.data;
              break;
          case 'DOCUMENT_MASTER':
              state.helpDocumentList=action.payload.data;
              break;
          case 'BULK_PAYMENT_PROCESS_CONFIG':
            state.bulkpaymentDashboardList = action.payload.data
            break
            case 'PAYMENT_DASHBOARD':
              state.paymentDashboardList = action.payload.data
              break
          case 'PAYMENT_RECEIPT':
              // if (action.payload.data?.result?.[0]){
              // for(const i in action.payload.data.result){
              //   action.payload.data.result[i].linerid = 1
              // }}
              state.receiptDashboardList = action.payload.data
              break
              // case 'EMAIL_TEMPLATE_DASHBOARD':
              case 'EMAIL_LOGS':
                
                // if (action.payload.data?.result?.[0]){
                // for(const i in action.payload.data.result){
                //   action.payload.data.result[i].linerid = 1
                // }}
                state.emailDashboardList = action.payload.data
                break
                case 'BL_REQUEST':
                  state.payorDashboardList = action.payload.data
                  break 
          case 'PICKUP_LOC_INSTRACT_REPORT':
            state.reportDashboardList = action.payload.data;
            break
            case 'INVOICE_INSTRUCTION':
              state.reportDashboardList = action.payload.data;
              break
               case 'FASAH_PAY_REPORT':
                state.reportDashboardList = action.payload.data;
                break
              case 'DELIVERY_ORDER_REPORT':
                state.reportDashboardList = action.payload.data;
                break
              case 'DO_EXTENSION_REPORT':
                state.reportDashboardList = action.payload.data;
                break
              case 'AGENT_NOMINATION_REPORT':
                state.reportDashboardList = action.payload.data;
                break
              case 'DETENTION_DEMURRAGE_REPORT':
                state.reportDashboardList = action.payload.data;
                break
              case 'PAYMENT_DASHBOARD_REPORT':
                state.reportDashboardList = action.payload.data;
                break
            case 'INVOICE_DETAILS_VN':
              state.reportDashboardList = action.payload.data;
              break
                case 'DO_INTEGRATION_REPORT':
              state.reportDashboardList = action.payload.data;
              break
          case 'CUSTOMER_DASHBOARD':
            state.mappingDashboardList = action.payload.data;
            break
          case 'SEZ_DASHBOARD':
          case 'sez_cert_req_detail':
            state.sezDashboardList = action.payload.data;
            break
          case 'GATE_DASHBOARD_CUSTOMER' :
            state.getInGetOutDashboardList = action.payload.data;
            break
          default:
            break;
        }
      }

      state.dataLoading = false;
    });

    builder.addCase(searchWithBlno.pending, (state, action) => {
      state.dataLoading = true;
    });
    builder.addCase(searchWithBlno.fulfilled, (state, action) => {
      state.dataLoading = false;
      state.data = action.payload;
    });
    builder.addCase(
      searchWithShipmentNoBlDashboard.pending,
      (state, action) => {
        state.dataLoading = true;
      }
    );
    builder.addCase(
      searchWithShipmentNoBlDashboard.fulfilled,
      (state, action) => {
        state.dataLoading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(searchWithInternalVoyageNo.pending, (state, action) => {
      state.dataLoading = true;
    });
    builder.addCase(searchWithInternalVoyageNo.fulfilled, (state, action) => {
      state.dataLoading = false;
      state.data = action.payload;
    });

    builder.addCase(searchWithShipmentno.pending, (state, action) => {
      state.dataLoading = true;
    });
    builder.addCase(searchWithShipmentno.fulfilled, (state, action) => {
      state.dataLoading = false;
      state.data = action.payload;
    });
    builder.addCase(searchWithContainerno.pending, (state, action) => {
      state.dataLoading = true;
    });
    builder.addCase(searchWithContainerno.fulfilled, (state, action) => {
      state.dataLoading = false;
      state.data = action.payload;
    });
    builder.addCase(
      searchWithInternalVoyageNoPaymentDashboard.pending,
      (state, action) => {
        state.dataLoading = true;
      }
    );
    builder.addCase(
      searchWithInternalVoyageNoPaymentDashboard.fulfilled,
      (state, action) => {
        state.dataLoading = false;
        state.data = action.payload;
      }
    );
    // todo bllist
    // builder.addCase(getBLListWithBlnumber.pending, (state, action) => {
    //   state.dataLoading = true;
    // });
    // builder.addCase(getBLListWithBlnumber.fulfilled, (state, action) => {
    //   state.dataLoading = false;
    //   state.data = action.payload;
    // });
  },
});

export const {
  updateCurrentPageBlDashboard,
  updateCurrentPageInvoiceDashboard,
  updateCurrentPageReceiptDashboard,
  updateCurrentPageEmailDashboard,
  updateCurrentPagePayorDashboard,
  updatePrveDependenciesBlDashboard,
  updateCurrentPageInstructionDashboard,
  updateCurrentPageUserDashboard,
  updateCurrentPageCustomerCodeDashboard,
  updateCurrentPageReportDashboard,
  updateCurrentPageRegistrationDashboard,
  updateCurrentPageStandingInst,
  updateSetDefaultViewBL,
  updateDashboardBlList,
  updateColumnDefinitionConfigs,
  updateColumnDefinition,
  updateSetDefaultViewInvoice,
  toggleColumnSettingsDashboard,
  toggleAddAgent,
  toggleAddAgentButton,
  toggleNominationReq,
  toggleIsBlExists,
  getPaymentStatus,
  getInstructionStatus,
  toggleDeliveryOrderEntry,
  getReleaseStatus,
  updateSelectedTableData,
  updateSelectedRow,
  addSelectionToTableData,
  removeSelectionfromTable,
  updateCurrentPagePayment,
  updateCurrentPageMapping,
  updateCurrentPageSez,
  updateSelectedInstRow,
  updateAssigneTo,
  removeSelectionfromInstTable,
  clearDashboards,
  clearMappingDashboard,
  clearSezDashboard,
  setMyPaymentPopUp,
  setUsDashboardPopUp,
  setJoDashboardPopUp,
  setHkBlDashboardPopUp
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
